import React from "react";
import { connect } from "react-redux";
import moment from "moment";

import BaseFormContainer from "../../common/components/form/BaseFormContainer";

import * as productActions from "../../product/product.actions";
import * as transactionActions from "../transaction.actions";
import { getCurrentUser } from "../../user/user.selectors";
import { getCurrentCampaign } from "../../campaign/campaign.selectors";
import { getProductsFilteredByScore } from "../../product/product.selectors";
import { getProductCategoriesFiltered } from "../../product-category/product-category.selectors";
import CreateTransactionForm from "./CreateTransactionForm";
import { StyledCreateTransactionForm } from "./ui";
import { Localize } from "../../../locale/localization";

const constraints = {
  selectedProductCategory: {
    presence: {
      message: `^${Localize("form.create-transaction.product-category.error")}`
    }
  },
  selectedProduct: {
    presence: {
      message: `^${Localize("form.create-transaction.product.error")}`
    }
  },
  quantity: {
    numericality: {
      onlyInteger: true,
      greaterThan: 0,
      lessThanOrEqualTo: 10,
      notValid: `^${Localize("form.create-transaction.quantity.error")}`,
      notGreaterThan: `^${Localize("form.create-transaction.quantity.error")}`,
      notLessThanOrEqualTo: `^${Localize("form.create-transaction.quantity.error")}`
    }
  },
  date: {
    presence: {
      message: `^${Localize("form.create-transaction.date.error")}`
    }
  }
};

const baseFormData = {
  selectedProductCategory: "",
  selectedProduct: "",
  quantity: "",
  date: "",
  salesId: ""
};

class CreateTransactionFormContainer extends BaseFormContainer {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      formData: Object.assign({}, baseFormData)
    };
  }
  componentWillMount = () => {
    const { getProducts } = this.props;
    getProducts(true);
  };

  getConstraints = () => constraints;

  applyFormDataChange = changes => {
    if (changes.selectedProductCategory) {
      // product category was changed
      const productOptions = this.props.products
        .filter(product => product.productCategory === changes.selectedProductCategory)
        .map(product => product._id);
      // if only one product available, select that, otherwise select nothing
      changes.selectedProduct = productOptions.length === 1 ? productOptions[0] : "";
    }
    return Object.assign({}, this.state.formData, changes);
  };

  updateData = event => {
    const target = event.target;
    const { value, name } = target;
    if (name === "") return;

    if (name === "selectedProductCategory") {
      const productOptions = this.props.products
        .filter(product => product.productCategory === value)
        .map(product => product._id);
      if (productOptions.length === 1) {
        const formData = Object.assign({}, this.state.formData, {
          selectedProduct: productOptions[0]
        });
        this.setState(
          {
            formData: {
              ...formData,
              [name]: value
            }
          },
          () => {
            this.validate();
          }
        );
        return;
      }
    }

    super.updateData(event);
  };

  doSubmit = formData => {
    const { createTransaction, currentUser } = this.props;
    const { selectedProduct, quantity, date, salesId } = formData;
    const modifiedFormData = {
      user: currentUser._id,
      productId: selectedProduct,
      quantity,
      salesId,
      timestamp: moment(date, "D.M.YYYY").unix() * 1000
    };
    createTransaction(modifiedFormData).then(action => {
      this.reset();
      if (action.response && action.response.status === "ok") {
        this.setState({
          submitCompleted: true,
          submitted: true
        });
      } else {
        this.setState({
          submitFailed: true,
          submitted: true
        });
      }
      this.setState({
        formData: Object.assign({}, baseFormData)
      });
    });
  };

  render() {
    const { currentCampaign } = this.props;
    const { startDate, endDate } = currentCampaign;

    return (
      <StyledCreateTransactionForm>
        <CreateTransactionForm
          enabled={!this.state.isSubmitting && !!endDate}
          fieldsEnabled={!!endDate}
          onSubmit={this.onSubmit}
          onInputChange={this.onInputChange}
          onBlur={this.onBlur}
          errors={this.state.errors}
          touchedFields={this.state.touchedFields}
          isValid={this.state.isValid}
          products={this.props.products}
          productCategories={this.props.productCategories}
          selectedProductCategory={this.state.formData.selectedProductCategory}
          selectedProduct={this.state.formData.selectedProduct}
          quantity={this.state.formData.quantity}
          date={this.state.formData.date}
          firstPossibleDate={startDate}
          lastPossibleDate={endDate}
          salesId={this.state.formData.salesId}
        />
      </StyledCreateTransactionForm>
    );
  }
}

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);
  const currentCampaign = getCurrentCampaign(state);
  const products = getProductsFilteredByScore(state);
  const productCategories = getProductCategoriesFiltered(state);

  return {
    currentCampaign,
    currentUser,
    products,
    productCategories
  };
};

const ConnectedCreateTransactionFormContainer = connect(
  mapStateToProps,
  Object.assign({}, transactionActions, productActions)
)(CreateTransactionFormContainer);

export default ConnectedCreateTransactionFormContainer;



// WEBPACK FOOTER //
// ./src/modules/transaction/components/CreateTransactionFormContainer.js